import { combineReducers } from 'redux'

import isImportSpreadsheetsDialogOpen from './isImportSpreadsheetsDialogOpen'
import importFileUploading from './importFileUploading'

export default combineReducers({
  isImportSpreadsheetsDialogOpen,
  importFileUploading,
})
